const StatItem = ({ name, value }) => (
  <div className="flex flex-col-reverse gap-1">
    <dt className="text-base/7 text-gray-300">{name}</dt>
    <dd className="text-4xl font-semibold tracking-tight text-white">{value}</dd>
  </div>
);

export default StatItem;